export default function VendorDetailIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 26 25"
      fill="none"
    >
      <path
        d="M2.17399 1.00007C2.01983 1.00007 1.86718 1.03046 1.72475 1.0895C1.58232 1.14854 1.45291 1.23508 1.3439 1.34417C1.2349 1.45327 1.14843 1.58278 1.08943 1.72532C1.03044 1.86785 1.00007 2.02063 1.00007 2.17491V23.3872C0.998347 23.5426 1.02744 23.6967 1.08566 23.8408C1.14388 23.9848 1.23008 24.1159 1.33926 24.2264C1.44844 24.3368 1.57843 24.4246 1.72172 24.4844C1.865 24.5443 2.01872 24.5751 2.17399 24.5751H18.674C18.9888 24.5751 19.2907 24.4499 19.5133 24.2271C19.7359 24.0044 19.861 23.7022 19.861 23.3872V2.17491C19.861 2.01952 19.8302 1.86568 19.7704 1.72228C19.7106 1.57889 19.6229 1.44879 19.5125 1.33952C19.4022 1.23026 19.2712 1.14399 19.1273 1.08573C18.9833 1.02746 18.8293 0.998346 18.674 1.00007L9.34784 1.00007V8.8323L6.73914 6.22156L4.13044 8.8323V1.00007L2.17399 1.00007Z"
        stroke="#212121"
        strokeWidth="0.85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.7826 22.9293C22.6641 22.9293 25 20.5916 25 17.7078C25 14.8241 22.6641 12.4863 19.7826 12.4863C16.9011 12.4863 14.5652 14.8241 14.5652 17.7078C14.5652 20.5916 16.9011 22.9293 19.7826 22.9293Z"
        fill="white"
        stroke="#212121"
        strokeWidth="0.85"
      />
      <path
        d="M19.7826 16.6648C20.3589 16.6648 20.8261 16.1972 20.8261 15.6205C20.8261 15.0437 20.3589 14.5762 19.7826 14.5762C19.2063 14.5762 18.7391 15.0437 18.7391 15.6205C18.7391 16.1972 19.2063 16.6648 19.7826 16.6648Z"
        stroke="#212121"
        strokeWidth="0.85"
      />
      <path
        d="M21.8696 19.7976C21.814 18.5897 21.5045 17.709 19.7826 17.709C18.0608 17.709 17.7513 18.5897 17.6957 19.7976"
        stroke="#212121"
        strokeWidth="0.85"
        strokeLinecap="round"
      />
      <path
        d="M4.13049 14.4258H12.4783"
        stroke="#212121"
        strokeWidth="0.85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4783 4.13281L16.6522 4.13281"
        stroke="#212121"
        strokeWidth="0.85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4783 8.31055L16.6522 8.31055"
        stroke="#212121"
        strokeWidth="0.85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4783 18.6016H4.13049"
        stroke="#212121"
        strokeWidth="0.85"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
